import React from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { closeConnectionModal } from '../../integrationsSlice'
import { linkFromChannel } from '../../../../modules/account'

/**
 * ChannelAdvisor Connection Modal
 *
 * This modal is used to initiate the ChannelAdvisor OAuth flow.
 *
 * @returns {React.ReactNode} - The ChannelAdvisor connection modal
 */
export default function ChannelAdvisorConnectionModal() {
  const dispatch = useDispatch()

  // Cancel Button Click Handler
  const closeModal = () => {
    return dispatch(closeConnectionModal())
  }

  // Connect Button Click Handler
  const connect = () => {
    // Start the ChannelAdvisor OAuth flow
    linkFromChannel('channeladvisor')
  }

  return (
    <div className="tw-p-6">
      <h2 className="tw-text-xl tw-mb-6">Connect ChannelAdvisor (Rithum)</h2>

      <div className="tw-mb-6">
        <p className="tw-mb-4">
          Connect your ChannelAdvisor account to automatically sync:
        </p>

        <ul className="tw-list-disc tw-list-inside tw-space-y-2 tw-text-sm tw-text-gray-700 tw-mb-4">
          <li><strong>Marketplace Data</strong> - Sync inventory, orders, and costs across Amazon, eBay, Walmart, and more.</li>
          <li><strong>Real-time Insights</strong> - Gain real-time stock visibility, unified analytics, and added cost insights.</li>
          <li><strong>Enhanced Data</strong> - ChannelAdvisor centralizes marketplace data, complementing your existing connections with streamlined multi-channel operations.</li>
        </ul>
      </div>

      <div className="tw-flex tw-items-center tw-justify-end tw-space-x-2">
        <Button variant="secondary" onClick={closeModal}>
          Cancel
        </Button>
        <Button onClick={connect} className="tw-bg-blue-600 tw-border-blue-600">
          <span className="fa fa-external-link tw-mr-2"></span>
          Connect ChannelAdvisor
        </Button>
      </div>
    </div>
  )
}
